import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import { MenuItem } from "types";

import MobileMenuItem from "./MobileMenuItem";
import { navbar } from "data/menus/navbar";
import hamburgerIcon from "assets/icons/Hamburger-Menu-Icon.svg";
import { useAuth } from "contexts/AuthContext";
import { Link } from "react-router-dom";

type MobileMenuProps = {
  toggleDropdown: boolean;
  setToggleDropdown: Dispatch<SetStateAction<boolean>>;
  onToggle: () => void;
};

type ContainerProps = {
  readonly toggleDropdown: boolean;
};

const MobileMenu: React.FC<MobileMenuProps> = ({
  toggleDropdown,
  setToggleDropdown,
  onToggle,
}) => {
  const { currentUser } = useAuth();

  const handleAccess = (menu: MenuItem) => {
    if (menu.access.length > 0) {
      return currentUser && menu.access.includes(currentUser.role);
    } else if (currentUser && menu.key === "signin") {
      return false;
    }

    return menu;
  };

  return (
    <Container>
      <Button onClick={onToggle}>
        <img src={hamburgerIcon} alt="mobile menu icon" />
      </Button>
      <Dropdown toggleDropdown={toggleDropdown}>
        {navbar
          .filter(({ menu }) => handleAccess(menu))
          .map(({ menu }) => (
            <MobileMenuItem
              key={menu.key}
              menu={menu}
              isDropdown={menu.childMenu.length > 0}
              setToggleDropdown={setToggleDropdown}
            />
          ))}
        <Links>
          <li>
            <ExternalLink to={navbar[2].menu.path}>
              {navbar[2].menu.name}
            </ExternalLink>
          </li>
          <li>
            <ExternalLink to={navbar[3].menu.path}>
              {navbar[3].menu.name}
            </ExternalLink>
          </li>
          <li>
            <ExternalLink to={navbar[4].menu.path}>
              {navbar[4].menu.name}
            </ExternalLink>
          </li>
        </Links>
      </Dropdown>
    </Container>
  );
};

const Container = styled.div`
  display: none;

  @media screen and (max-width: 1290px) {
    display: block;
    margin: auto 0;
  }
`;

const Button = styled.button`
  padding: 0;
  margin-right: 1rem;
  margin-top: 3px;

  &:hover {
    opacity: 0.8;
  }
`;

const Dropdown = styled.div<ContainerProps>`
  background-color: ${(props) => props.theme.colors.idataDarkBlue};
  color: #fff;
  display: ${(props) => (props.toggleDropdown ? "block" : "none")};
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 0 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
`;

const Links = styled.ul`
  display: flex;
  flex-wrap: wrap;

  > *:not(:last-child) {
    margin-right: 5%;
  }
`;

const ExternalLink = styled(Link)`
  color: #fff;
  display: block;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export default MobileMenu;
